import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { Section } from './ui/Section';
export function FAQ() {
  const faqs = [{
    q: '¿El material es 100% digital? ¿Cómo lo recibo?',
    a: 'Sí. Es 100% digital. Tras la compra recibes acceso inmediato a todos los PDFs en tu email en menos de 5 minutos.'
  }, {
    q: '¿Necesito experiencia cocinando?',
    a: 'No. El sistema está diseñado para personas que cocinan en casa de forma normal. Cada receta incluye el paso a paso completo con ingredientes que encuentras en cualquier Mercadona o Lidl.'
  }, {
    q: '¿Son solo recetas?',
    a: 'No. Las recetas son la parte práctica, pero el sistema te enseña primero la lógica del mimetismo: por qué cada ingrediente hace lo que hace y cómo sustituirlo. Así puedes adaptar cualquier receta tuya sin depender de nadie.'
  }, {
    q: '¿Puedo usarlo desde el móvil?',
    a: 'Sí. Recibes los PDFs directamente en tu email y puedes abrirlos desde el móvil, tablet u ordenador. Sin apps, sin contraseñas, sin plataformas raras.'
  }, {
    q: '¿Necesito ingredientes difíciles de conseguir?',
    a: 'No. El Bono 2 incluye una ruta de compra específica para Mercadona, Lidl y Carrefour. Todo lo que necesitas está disponible en supermercados españoles normales.'
  }, {
    q: '¿Necesito tener celiaquía o intolerancia al gluten?',
    a: 'No. El sistema es útil para cualquier persona que quiera reducir o eliminar el gluten de su alimentación, tenga o no diagnóstico médico. Si tienes celiaquía, es especialmente útil porque te enseña a cocinar con seguridad real.'
  }, {
    q: '¿Puedo seguir comiendo fuera en bares y restaurantes?',
    a: 'Sí. El Bono 5 (Guía Social Sin Gluten) está diseñado exactamente para eso: cómo pedir en bares, restaurantes, bodas y reuniones familiares sin dar explicaciones ni quedarte con hambre.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggle = (i: number) => setOpenIndex(prev => prev === i ? null : i);
  return <Section data-id="element-76" data-mp="2pmwv7l9j656d">
      <h2 className="font-display text-2xl md:text-4xl font-bold text-center mb-10 text-brand-title" data-id="element-77" data-mp="2pnoouqjkhsu0">
        Preguntas frecuentes
      </h2>

      <div className="max-w-2xl mx-auto space-y-3" data-id="element-78" data-mp="2ku3pov68mst8">
        {faqs.map((faq, i) => {
        const isOpen = openIndex === i;
        return <div key={i} className="bg-white border border-brand-border rounded-xl shadow-card overflow-hidden" data-id="element-79" data-mp="2ay91lkj8w5j2" data-mpi={i}>
              <button onClick={() => toggle(i)} aria-expanded={isOpen} className="w-full flex items-center justify-between gap-3 text-left px-5 py-4" data-id="element-80" data-mp="38lr7mnliutjd">
                <span className="font-heading font-bold text-brand-title text-sm md:text-base" data-id="element-81" data-mp="33klguvbf9gch">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-primary shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-82" data-mp="2umhxa4jzytnb" />
              </button>
              {isOpen && <p className="font-body text-brand-text text-sm leading-relaxed px-5 pb-4" data-id="element-83" data-mp="1j6kw9hyvwj9q">
                  {faq.a}
                </p>}
            </div>;
      })}
      </div>
    </Section>;
}